<template>
  <div>
    <multiselect
      v-model="inputValue"
      :options="optionsGames"
      @input="setValue"
      :multiple="true"
      selectLabel=""
      label="nome"
      track-by="id"
      selectedLabel="«"
      deselectLabel=""
      placeholder=""
      :close-on-select="false"
    >
      <template slot="tag" slot-scope="{ option, remove }">
        <span class="badge badge-primary mr-1">
          <span class="text-truncate mr-1 mb-1"> {{ option.nome }} ({{ option.id }}) </span>
          <span class="custom__remove badge" @mousedown.prevent.stop="remove(option)"> x </span>
        </span>
      </template>
    </multiselect>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';

export default {
  components: {
    Multiselect
  },
  props: ['labelTitle', 'options', 'modelValue', 'idSite', 'provider'],
  emits: ['setValue'],
  data() {
    return {
      inputValue: this.modelValue,
      optionsGames: []
    };
  },
  mounted() {
    this.getGames();
  },
  watch: {
    modelValue() {
      this.inputValue = this.modelValue;
    },
    provider() {
      this.getGames();
    },
    idSite() {
      this.getGames();
    }
  },
  methods: {
    getGames() {
      this.optionsGames = [];

      if (!this.idSite) {
        return;
      }
      if (!this.provider) {
        return;
      }
      this.$atenaList
        .getCommon('game', {
          limit: -1,
          columns: 'id_game, nome_game',
          filter: `id_localidade_Web = ${this.idSite} and ativo = true and provider = '${this.provider}'`
        })
        .then((res) => {
          this.optionsGames = res.data.map((item) => ({
            id: item.id_game,
            nome: item.nome_game
          }));
        });
    },
    setValue() {
      this.$emit('setValue', this.inputValue);
    }
  }
};
</script>

<style lang="scss">
.multiselect-primary {
  .multiselect__tags {
    display: flex !important;
  }
}
</style>
